import { render } from "./ShopOnlineCD.vue?vue&type=template&id=4089eb5e"
import script from "./ShopOnlineCD.vue?vue&type=script&lang=js"
export * from "./ShopOnlineCD.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__